;(function($) {

	"use strict";

	var animationEndEvent = 'webkitAnimationEnd oAnimationEnd MSAnimationEnd animationend';
	var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
	var lazyLoadRefreshEvent = 'lazyload.refresh';
	var skrollrOptions = {
		smoothScrolling: false,
		forceHeight:     false,
		mobileCheck:     function() {
			return false;
		}
	};

	window.lazySizesConfig.throttleDelay = 66;
	window.lazySizesConfig.preloadAfterLoad = true;

	$(document).ready(function() {

		//==================================
		//	!---------- GLOBAL ----------
		//==================================

		// ---------- Replace hover rules by active on touchscreens ----------

		if(!!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator)) {
			for(var sheetI = document.styleSheets.length - 1; sheetI >= 0; sheetI--) {
				var sheet = document.styleSheets[sheetI];
				if(sheet.cssRules) {
					for(var ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
						var rule = sheet.cssRules[ruleI];

						if(rule.selectorText) {
							rule.selectorText = rule.selectorText.replace(':hover', ':active');
						}
					}
				}
			}
		}

		if(navigator.userAgent.match(/Trident\/7\./)) { // if IE
			$('body').on("mousewheel", function (event) {
				// remove default behavior
				event.preventDefault();

				//scroll without smoothing
				var wheelDelta = event.wheelDelta;
				var currentScrollPosition = window.pageYOffset;
				window.scrollTo(0, currentScrollPosition - wheelDelta);
			});
		}

		// ---------- Menu ----------

		$('.menu-overlay').click(function(e) {
			e.preventDefault();
			$('body').removeClass('menu-open');
		});

		$('.menu-toggle').click(function(e) {
			e.preventDefault();
			$('body').toggleClass('menu-open');
			$('body').scrollTop(0);
		});

		// ---------- Links ----------

		$('a[href="#"], .void-link').click(function(e) {
			e.preventDefault();
		});

		$('[data-scroll-to]').click(function(e) {
			e.preventDefault();

			var self = $(this);
			var target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

			if(target.length) {
				var offset = (target.offset().top > 320) ? target.offset().top - 80 : 0;
				$('html, body').animate({
					scrollTop: offset
				}, 1000);
			}
		});

		// ---------- Animsition ----------

		$('.main-wrapper').animsition({
			inClass:     'fade-in',
			outClass:    'fade-out',
			inDuration:  500,
			outDuration: 500,
			linkElement: 'a:not([target="_blank"]):not([href^="#"]):not([href^="mailto:"]):not([href^="tel:"]):not(.void-link):not([data-lity])',
			loading:     false,
		});

		//==============================================
		//	!---------- ANIMATIONS TRIGGER ----------
		//==============================================

		$('.main-wrapper').on('animsition.inStart', function() {

			$('.preloader').fadeOut(1, function() {
				var self = $(this);
				self.remove();
				$('body').removeClass('loading');
			});

		});

		// ---------- Carousels ----------

		$('.masonry').each(function() {
			var self = $(this);

			self.isotope({
				masonry:      {
					percentPosition: true
				},
				itemSelector: ".single-column"
			})
		});

		$('.page-title .carousel').each(function() {

			var self = $(this);

			var active = self.find('.single-column.active').index();

			var settings = {
				arrows:         false,
				infinite:       false,
				centerMode:     false,
				slidesToShow:   7,
				slidesToScroll: 7,
				responsive:     [
					{
						breakpoint: 768,
						settings:   {
							slidesToShow:   5,
							slidesToScroll: 5
						}
					},
					{
						breakpoint: 480,
						settings:   {
							slidesToShow:   3,
							slidesToScroll: 3
						}
					}
				]
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(lazyLoadRefreshEvent);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
				self.slick('goTo', active);
			}
		});

		$('.carousel').each(function() {

			var self = $(this);

			var settings = {
				dots:           true,
				arrows:         false,
				infinite:       false,
				centerMode:     false,
				slidesToShow:   3,
				slidesToScroll: 3,
				responsive:     [
					{
						breakpoint: 1024,
						settings:   {
							slidesToShow:   2,
							slidesToScroll: 2
						}
					},
					{
						breakpoint: 600,
						settings:   {
							slidesToShow:   1,
							slidesToScroll: 1
						}
					}
				]
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(lazyLoadRefreshEvent);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
			}
		});

		$('.slideshow').each(function() {

			var self = $(this);

			var settings = {
				infinite:      true,
				autoplaySpeed: 3000,
				arrows:        false,
				autoplay:      true,
				speed:         2000,
				fade:          true,
			};

			self.on('init reInit beforeChange afterChange', function() {
				$(window).trigger(lazyLoadRefreshEvent);
			});

			if(!self.hasClass('slick-initialized')) {
				self.slick(settings);
			}
		});

		$('.gallery').each(function() {
			var self = $(this);

			self.lightGallery({
				download: false,
			});
		});

		// ---------- Skrollr ----------

		function skrollrInit() {
			skrollr.init(skrollrOptions);
		}

		$(window).debounce('resize', function() {
			var skrollrInstance = skrollr.get();

			if(window.innerWidth <= 767 && skrollrInstance !== undefined) {
				skrollrInstance.destroy();
			}
			else if(window.innerWidth > 767 && skrollrInstance === undefined) {
				skrollrInit();
			}
		}, 200);

		$(window).trigger('resize');

		$(window).throttle('scroll', function() {
			var finished = $('.skrollable-after.one-way');
			var skrollrInstance = skrollr.get();

			finished.each(function() {
				var self = $(this).removeClass('skrollable-after'),
				    data = {};

				// identify data- attributes on element
				$.each(this.attributes, function() {
					if(this.specified && this.name.indexOf('data-') === 0) {
						data[this.name] = true;
					}
				});

				// and now remove identified attributes
				for(var d in data) {
					self.removeAttr(d);
				}
			});

			if(finished.length) {
				skrollrInstance.destroy();
				skrollrInit();
			}
		}, 200);

		$(window).trigger('scroll');

		$(window).on('load', function() {

			$(window).trigger('resize');
			$(window).trigger('scroll');

		});

		// ---------- LazyLoad ----------

		$(window).on(lazyLoadRefreshEvent, function() {

			window.lazySizes.loader.checkElems();
			window.lazySizes.autoSizer.checkElems();

		});

		$(window).trigger(lazyLoadRefreshEvent);

		// ---------- Vide ----------

		$(window).on('load', function() {

			$('.video-background').each(function() {
				var self = $(this);
				var video = self.data('video');
				var poster = self.data('poster');

				self.vide({
					mp4:    video,
					poster: poster
				}, {
					posterType: 'jpg'
				})
			});

		});

		if($('#instafeed').length) {
			var feed = new Instafeed({
				get:         'user',
				userId:      '7187681843',
				resolution:  'standard_resolution',
				clientId:    'e86917bc46b0430eb193320745c35196',
				accessToken: '7187681843.1677ed0.36b22ff098d94e48be96a21fac1fca5a',
				limit:       8,
				template:    '<div class="instagram-image col-6 col-sm-3 col-md"><a href="{{link}}" target="_blank"><div class="wrapper"><img class="image lazyload" data-src="{{image}}" /></div></a></div>',
			});
			feed.run();
		}

	});

}(jQuery));
